import type { ReactNode } from "react";
import classnames from "classnames";

import style from "./style.module.scss";
import { Stepper } from "../../../ui";

interface WizardFooterProps {
  uid?: string;
  step: number;
  enabledSteps: number[];
  children?: ReactNode;
  className?: string;
}

function WizardFooter({ uid, step, enabledSteps, children, className }: WizardFooterProps) {
  const steps = [
    {
      id: "upload",
      label: "Photos",
      link: `/upload/${uid}`,
      isActive: step === 1,
      isDisabled: enabledSteps.indexOf(1) === -1,
    },
    {
      id: "settings",
      label: "Couverture",
      link: `/settings/${uid}`,
      isActive: step === 2,
      isDisabled: enabledSteps.indexOf(2) === -1,
    },
    {
      id: "create",
      label: "Pages",
      link: `/customize/${uid}`,
      isActive: step === 3,
      isDisabled: enabledSteps.indexOf(3) === -1,
    },
    {
      id: "ship",
      label: "Livraison",
      link: `/shipping/${uid}`,
      isActive: step === 4,
      isDisabled: enabledSteps.indexOf(4) === -1,
    },
  ];

  return (
    <div className={classnames(style.footer, className)}>
      <div className={style.inner}>
        <div className={style.stepper}>
          <Stepper steps={steps} />
        </div>
        <div className={style.actions}>{children}</div>
      </div>
    </div>
  );
}

export default WizardFooter;
